// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"920516eb","800":"af08c651","946":"85d55f71"}[chunkId] + ".chunk.js";
};